import axiosInstance from 'helpers/axiosInstance';

export interface InsuranceCredentials {
  sponsor_id?: string;
  member_id?: string;
  group_number?: string;
  payer_id?: string;
  insurance_phone?: string;
  member_first_name?: string;
  member_last_name?: string;
  member_dob?: string;
  is_medicaid?: boolean;
  front_card?: File;
  back_card?: File;
  lead_id?: string;
}

interface EligibilityResponse {
  result: string;
}

export const checkEligibility = (data: InsuranceCredentials, patientConsultId: string) => {
  const url = `/patients/patients/${patientConsultId}/eligibility_inquire`;
  const formData = new FormData();
  formData.append('insurance[sponsor_id]', data.sponsor_id || '');
  formData.append('insurance[member_id]', data.member_id || '');
  formData.append('insurance[group_number]', data.group_number || '');
  formData.append('insurance[payer_id]', data.payer_id || '');
  formData.append('insurance[insurance_phone]', data.insurance_phone || '');
  formData.append('insurance[member_first_name]', data.member_first_name || '');
  formData.append('insurance[member_last_name]', data.member_last_name || '');
  formData.append('insurance[member_dob]', data.member_dob || '');
  formData.append('insurance[lead_id]', data.lead_id || '');
  if (data.front_card) {
    formData.append('insurance[front_card]', data.front_card);
  }
  if (data.back_card) {
    formData.append('insurance[back_card]', data.back_card);
  }
  return axiosInstance
    .post<EligibilityResponse>(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      return error;
    });
};
